import {
  Divider,
  Flex,
  ModalFooter as ModalFooterPrimitive,
  type ModalFooterProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function ModalFooter({
  children,
  justifyContent = 'end',
  gap,
  ...props
}: ModalFooterProps): ReactNode {
  return (
    <ModalFooterPrimitive p="0" display="block" {...props}>
      <Divider />
      <Flex
        py="4"
        px="6"
        justifyContent={justifyContent}
        gap={justifyContent === 'end' ? 'space_unit.x1' : gap}
      >
        {children}
      </Flex>
    </ModalFooterPrimitive>
  );
}
